document.addEventListener("DOMContentLoaded", () => {
  const overlay   = document.getElementById("ai-search-overlay");
  const openBtn   = document.getElementById("open-search");
  const closeBtn  = document.getElementById("close-search");
  const toggleBtn = document.getElementById("mobile_search_toggle");
  const form      = document.getElementById("ai-search-form");
  const header = document.querySelector(".pre-search-ai__header");
  const queryInput = document.getElementById("searchQuery");

  // --- Example buttons: click to auto-fill search field ---
document.querySelectorAll("[data-ai-example]").forEach(btn => {
  btn.addEventListener("click", () => {
    const text = btn.getAttribute("data-ai-example");
    if (!queryInput) return;

    queryInput.value = text;

    // Optional: bring focus so user can hit Enter instantly
    queryInput.focus();
  });
});


  // --- Overlay open/close ---
  function openOverlay() {
    if (overlay) overlay.style.display = "flex";
  }

  function closeOverlay() {
    if (overlay) overlay.style.display = "none";
  }

  if (openBtn) {
    openBtn.addEventListener("click", openOverlay);
  }

  if (closeBtn) {
    closeBtn.addEventListener("click", closeOverlay);
  }

  if (overlay) {
    overlay.addEventListener("click", e => {
      // click outside inner content closes overlay
      if (e.target === overlay) closeOverlay();
    });
  }

  if (toggleBtn) {
    toggleBtn.addEventListener("click", () => {
      if (!overlay) return;
      const isOpen = overlay.style.display === "flex";
      overlay.style.display = isOpen ? "none" : "flex";
    });
  }

  // --- Styles for centered spinner + text ---
  function ensureLoadingStyles() {
    if (document.getElementById("ai-search-loading-style")) return;

    const css = `
@keyframes ai-search-spin { 
  to { transform: rotate(360deg); }
}
.ai-search-loading-wrapper {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.ai-search-loading {
  text-align: center;
  max-width: 320px;
}
.ai-search-loading-title {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 16px;
}
.ai-search-spinner {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 4px solid rgba(0,0,0,0.08);
  border-top-color: #7b0008;
  animation: ai-search-spin 0.8s linear infinite;
  margin: 0 auto 12px auto;
}
.ai-search-loading-subtitle {
  font-size: 14px;
  opacity: 0.8;
  max-width: 260px;
  margin: 0 auto;
}
    `.trim();

    const style = document.createElement("style");
    style.id = "ai-search-loading-style";
    style.textContent = css;
    document.head.appendChild(style);
  }

  // --- Show loading screen inside overlay, hide form ---
  function showLoadingScreen() {
    if (!overlay) return;

    ensureLoadingStyles();

    // Hide the input form while loading
    if (form) {
      form.style.opacity = "0";
      form.style.pointerEvents = "none";
    }

    if(header) {
      header.style.display = "none";
    }
    // Remove any previous loading block
    const old = document.getElementById("ai-search-loading-block");
    if (old) old.remove();

    const wrapper = document.createElement("div");
    wrapper.className = "ai-search-loading-wrapper";
    wrapper.id = "ai-search-loading-block";

    wrapper.innerHTML = `
      <div class="ai-search-loading">
        <p class="ai-search-loading-title">
          ${translations["ai-search-searching-title"] || "Searching"}
        </p>
        <div class="ai-search-spinner"></div>
        <p class="ai-search-loading-subtitle">
          ${
            translations["ai-search-searching-subtitle"]
            || "Our AI is searching the entire catalogue for the best results..."
          }
        </p>
      </div>
    `;

    overlay.appendChild(wrapper);
  }

  // --- Search submit handler ---
  if (form) {
    form.addEventListener("submit", async e => {
      e.preventDefault();

      const query = queryInput ? queryInput.value.trim() : "";
      if (!query) return;

      // Make sure overlay is visible during search
      openOverlay();

      // Show loading state
      showLoadingScreen();

      try {
        const response = await fetch("https://regencychess.co.uk/ai-search/search.php", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ query }),
        });

        const data = await response.json();

        if (!data.results || data.results.length === 0) {
          // If you want a nicer "no results" UX, you could show a toast or alert here
          alert(translations["ai-search-no-results"] || "No results found for your search.");
          closeOverlay();
          if (form) {
            form.style.opacity = "1";
            form.style.pointerEvents = "auto";
          }
          const loadingBlock = document.getElementById("ai-search-loading-block");
          if (loadingBlock) loadingBlock.remove();
          return;
        }

        // --- Build USF aisearch URL from SKUs (fallback to Handle) ---
        const skuList = data.results
          .map(item => item.Sku || item.sku || item.SKU || item.Handle)
          .filter(Boolean);

        if (skuList.length === 0) {
          alert(translations["ai-search-no-results"] || "No results found for your search.");
          closeOverlay();
          const loadingBlock = document.getElementById("ai-search-loading-block");
          if (loadingBlock) loadingBlock.remove();
          if (form) {
            form.style.opacity = "1";
            form.style.pointerEvents = "auto";
          }
          return;
        }

        const usfValue     = skuList.join("_usf_");
        const usfParamName = "uff_19ks1a_metafield%3Acustom.handle";

        const aisearchUrl =
          `${window.location.origin}/collections/aisearch?` +
          `${usfParamName}=${encodeURIComponent(usfValue)}`;

        // Redirect straight to the aisearch collection
        window.location.href = aisearchUrl;

      } catch (err) {
        console.error(err);
        alert(
          translations["ai-search-error-fetching"]
          || "There was an error while searching. Please try again."
        );

        // Reset UI on error
        const loadingBlock = document.getElementById("ai-search-loading-block");
        if (loadingBlock) loadingBlock.remove();
        if (form) {
          form.style.opacity = "1";
          form.style.pointerEvents = "auto";
        }
      }
    });
  }
});
